import React from "react";

export function Container({ children, className = "" }) {
  return <div className={`mx-auto w-full max-w-7xl px-5 sm:px-6 lg:px-8 ${className}`}>{children}</div>;
}

export function Section({ children, className = "", id, as: Tag = "section" }) {
  return (
    <Tag id={id} className={`py-20 sm:py-24 lg:py-28 ${className}`}>
      {children}
    </Tag>
  );
}

export function Eyebrow({ children, className = "", onDeep = false }) {
  return (
    <p
      className={`text-xs font-bold uppercase tracking-[0.22em] ${
        onDeep ? "text-etap-mint-200" : "text-etap-primary"
      } ${className}`}
    >
      {children}
    </p>
  );
}

export function Badge({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border border-etap-mint-300 bg-etap-mint-100 px-4 py-1.5 text-xs font-semibold text-etap-deep-700 ${className}`}
    >
      {children}
    </span>
  );
}
